import React, {useImperativeHandle, useRef} from "react";
import {useModel} from "../../../models";
import {DICT_KEY, getDictNameByCode} from "../../../utils/constants";

const borderStyle = {
    border: "1px double #000",
}
const PrintTitle = () => {
    return (
        <h3 style={{
            textAlign: "center",
            fontSize: "18pt",
            fontFamily: "楷体,楷体_GB2312",
        }}>
            采购单
        </h3>
    )
};
const PrintHeader = ({params: {purchaseCode, supplierId}}) => {
    return (
        <div style={{display: "flex"}}>
            <div style={{
                flex: "1",
                textAlign: "left"
            }}>
                采购单号:<span style={{marginLeft: "12px"}}>{purchaseCode}</span>
            </div>
            <div
                style={{
                    flex: "1",
                    textAlign: "left"
                }}
            >
                供应商名称:
                <span style={{marginLeft: "12px"}}>
                    {getDictNameByCode(DICT_KEY.CM_DICT.SUPPLIER, supplierId)}
                </span>
            </div>
        </div>
    )
}
const PrintFooter = () => {
    const [{userInfo: {userName}}] = useModel("global");
    return (
        <div style={{display: "flex"}}>
            <div style={{
                flex: "2",
                textAlign: "left"
            }}>
                {/*经办人:<span style={{marginLeft: "12px"}}> </span>*/}
            </div>
            <div
                style={{
                    flex: "1",
                    textAlign: "left"
                }}>操作员:<span style={{marginLeft: "12px"}}>{userName}</span></div>
        </div>
    )
}
const PrintTable = ({
                        params: {
                            mappedList,
                            discount,
                            poTotalNum,
                            payableAmount

                        }
                    }) => {

    return (
        <table
            border="0"
            align="center"
            style={{
                borderCollapse: "collapse",
            }}
            width="100%"
        >
            <thead style={{display: "table-header-group",}}>
            <tr bgcolor="#d3d3d3">
                <th style={borderStyle} width={140}>配件编码</th>
                <th style={borderStyle}>配件名称</th>
                <th style={borderStyle} width={140}>图号</th>
                <th style={borderStyle} width={100}>数量</th>
                <th style={borderStyle} width={100}>含税单价</th>
                <th style={borderStyle} width={120}>含税金额</th>
            </tr>
            </thead>
            <tbody>
            {
                mappedList.map(el => (
                    <tr key={el.id}>
                        <td style={borderStyle}>{el.materialCode}</td>
                        <td style={borderStyle}>{el.materialName}</td>
                        <td style={borderStyle}>{el.replaceNum}</td>
                        <td style={borderStyle}>{el.purchaseNum}</td>
                        <td style={borderStyle} align="right">{el.avgPrince}</td>
                        <td style={borderStyle} align="right">{el.amount}</td>
                    </tr>))
            }
            <tr bgcolor="#d3d3d3">
                <td style={borderStyle} colSpan={6}>
                    <div style={{display: "flex"}}>
                        <div style={{
                            flex: "1",
                            textAlign: "left"
                        }}>
                            整单折扣:<span style={{marginLeft: "12px"}}>{discount}%</span>
                        </div>
                        <div
                            style={{
                                flex: "1",
                                textAlign: "left"
                            }}
                        >
                            采购总数量:<span style={{marginLeft: "12px"}}> {poTotalNum}</span>
                        </div>
                        <div
                            style={{
                                flex: "1",
                                textAlign: "left"
                            }}
                        >
                            应付金额: <span style={{marginLeft: "12px"}}>{payableAmount}</span>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    )
}


export default ({printRef}) => {
    const ref = useRef();
    useImperativeHandle(printRef, () => ({
        dom: () => {
            return ref.current;
        },
    }));
    const [{
        selectedDocument: {purchaseCode, supplierId,},
        documentMaterialList,
        detailStatistics: {poTotalNum},
        formData
    },] = useModel("purchasePo");
    const {payableAmount = 0, discount = 100} = formData;
    const mappedList = documentMaterialList.map(el => {
        //平均价
        let avgPrince = el.purchaseAmount / el.purchaseNum;
        if (!!!avgPrince) {
            avgPrince = 0
        }
        /*//上进位
        avgPrince = (Math.ceil(avgPrince * 100) / 100);
        const amount = Math.ceil(avgPrince * el.purchaseNum * 100) / 100;*/
        //四舍五入
        avgPrince = avgPrince.toFixed(2);
        const amount = (avgPrince * el.purchaseNum).toFixed(2);

        return {
            ...el,
            avgPrince,
            amount
        };
    });
    return (
        <div ref={ref} hidden={true}>
            <div style={{width: "800px", margin: "0 auto"}}>
                <PrintTitle/>
                <PrintHeader params={{purchaseCode, supplierId}}/>
                <PrintTable params={{
                    mappedList,
                    discount,
                    poTotalNum,
                    payableAmount
                }}/>
                <PrintFooter/>
            </div>
        </div>
    )
}